<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 11,
            title: "RECINTOS FISCALIZADOS ESTRATEGICOS",
            columns: ["aduana", "descripcion", "actions"],
            options: {
                filterable: ["descripcion", "aduana"],
                sortable: ["descripcion", "aduana"],

                headings: {
                    aduana: "Aduana",
                    descripcion: "Descripción",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Descripción: "descripcion",
                Aduana: "aduana"
            },
            encabezadoLayout: {
                descripcion: "descripcion",
                aduana: "aduana"
            },
            camposLayout: [{
                descripcion: "[Descripción del Recinto Fiscalizado Estratégico]",
                aduana: "[Nombre de la Aduana]"
            }],
            model: {
                id: 0,
                descripcion: "",
                aduana: ""
            },
            form: {
                aduana: {
                    requiered: true,
                    label: "Aduana",
                    value: "",
                    maxlen: 200
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>